import { render, staticRenderFns } from "./StructureMap.vue?vue&type=template&id=63dddf5b&scoped=true"
import script from "./StructureMap.vue?vue&type=script&lang=js"
export * from "./StructureMap.vue?vue&type=script&lang=js"
import style0 from "./StructureMap.vue?vue&type=style&index=0&id=63dddf5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63dddf5b",
  null
  
)

export default component.exports